<template>
  <div class="wrap">
    <Menu :menu="menu" />
    <v-toolbar flat color="white">
      <v-toolbar-title> Результаты формы # {{ getFormId() }} </v-toolbar-title>
    </v-toolbar>
    <template v-if="items.length">
      <v-row justify="center">
        <v-expansion-panels accordion>
          <v-expansion-panel v-for="(item, i) in items" :key="i">
            <v-expansion-panel-header>{{
              item.created_at | formatDate
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                v-if="item.results.length"
                :headers="headers"
                :items="item.results"
                hide-default-footer
                disable-pagination
                :items-per-page="-1"
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </template>
    <template v-else>
      <v-card-text>
        Список пуст
      </v-card-text>
    </template>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" color="red">
      {{ errorText }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { API_URL_PREFIX } from "@/config/consts";
import Menu from "@/components/Menu.vue";
import { mapGetters } from "vuex";

export default {
  name: "FormsResult",
  data() {
    return {
      items: [],
      headers: [
        { text: "Поле", value: "name" },
        { text: "Значение", value: "value" }
      ],
      multiLine: true,
      snackbar: false,
      errorText: "",
      overlay: false
    };
  },
  components: {
    Menu
  },
  computed: {
    ...mapGetters(["getErrorText"]),
    menu() {
      return [
        { icon: "mdi-home", text: "На главную", link: "/" },
        {
          icon: "mdi-puzzle-plus",
          text: "Конструктор блоков",
          link: `/blocks?landing_id=${this.getCurrentLandingId()}`
        },
        {
          icon: "mdi-text",
          text: "Менеджмент",
          link: `/management?landing_id=${this.getCurrentLandingId()}`
        },
        {
          icon: "mdi-contacts",
          text: "Формы",
          link: `/forms?landing_id=${this.getCurrentLandingId()}`
        }
      ];
    }
  },
  async created() {
    await this.initialize();
  },
  methods: {
    getCurrentLandingId() {
      return this.$route.query.landing_id;
    },
    getFormId() {
      return this.$route.query.form_id;
    },
    async initialize() {
      await this.getBlockList();
    },
    async getBlockList() {
      try {
        const landingId = this.getCurrentLandingId();
        const formId = this.getFormId();

        this.overlay = true;
        const { data } = await this.$axios.get(
          `${API_URL_PREFIX}/landings/${landingId}/forms/${formId}/results`
        );
        this.items = data.list;
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
      } finally {
        this.overlay = false;
      }
    }
  }
};
</script>
